export const PDF_VIEWER_TAG_NAME = "pdf-viewer" as const;

export const PDF_VIEWER_TOOLS = [
  "pages",
  "zoom",
  "rotate",
  "search",
  "thumbnails",
  "download",
] as const;

export const PDF_VIEWER_ZOOM_MODES = [
  "automatic",
  "fit-page",
  "fit-width",
] as const;

export const PDF_VIEWER_ZOOM_PRESETS = [
  0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4,
] as const;

export const PDF_VIEWER_PAGE_GAP = 16;

export const PDF_VIEWER_VIEWPORT_GAP = 16;

// What the toolbar needs once it has shed everything it can and tightened the
// rest, in px because it is the sum of fixed control sizes and not a
// typographic measure. It holds to 310, and 320 is a real phone width.
export const PDF_VIEWER_MIN_WIDTH = 320;

export const PDF_VIEWER_THUMBNAIL_WIDTH = 104;

export const PDF_VIEWER_THUMBNAIL_GAP = 12;

export const PDF_VIEWER_THUMBNAIL_LABEL_HEIGHT = 26;

// Rows rendered above and below the pane's viewport. Upstream defaults to 3,
// which means a burst of renders the moment the pane opens on a long document.
export const PDF_VIEWER_THUMBNAIL_BUFFER = 1;

export const PDF_VIEWER_TILE_SIZE = 768;
